var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FEF2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0848 13.7242C12.3172 13.968 12.6925 13.968 12.9248 13.7242L15.6594 10.8555C15.7147 10.7976 15.7585 10.729 15.7884 10.6534C15.8183 10.5778 15.8337 10.4967 15.8337 10.4148C15.8337 10.333 15.8183 10.2519 15.7884 10.1763C15.7585 10.1007 15.7147 10.032 15.6594 9.97422L12.9248 7.10547C12.8697 7.04753 12.8043 7.00156 12.7322 6.9702C12.6601 6.93883 12.5828 6.92269 12.5048 6.92269C12.4268 6.92269 12.3495 6.93883 12.2775 6.9702C12.2054 7.00156 12.1399 7.04753 12.0848 7.10547C11.8584 7.34922 11.8524 7.74922 12.0848 7.99297L13.8006 9.79297H7.14585C6.81818 9.79297 6.55008 10.0742 6.55008 10.418C6.55008 10.7617 6.81818 11.043 7.14585 11.043H13.8006L12.0848 12.843C12.0296 12.9008 11.9858 12.9695 11.9559 13.0451C11.926 13.1207 11.9106 13.2017 11.9106 13.2836C11.9106 13.3654 11.926 13.4465 11.9559 13.5221C11.9858 13.5977 12.0296 13.6664 12.0848 13.7242ZM4.76276 14.168C5.09044 14.168 5.35854 13.8867 5.35854 13.543V7.29297C5.35854 6.94922 5.09044 6.66797 4.76276 6.66797C4.43509 6.66797 4.16699 6.94922 4.16699 7.29297V13.543C4.16699 13.8867 4.43509 14.168 4.76276 14.168Z",
    fill: "#FDB14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiated);
export default __webpack_public_path__ + "static/media/initiated.211c07c83ca29c4c62318aca0b9d6c21.svg";
export { ForwardRef as ReactComponent };